import { IStyle } from '../../ThemeContext/ThemeObject';
import { classes as sharedClasses } from '../styles';

export const classes: IStyle = {
  ...sharedClasses,
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12
  },
  editTabsContainer: {
    flexGrow: 1,
    display: 'flex',
    borderColor: 'none'
  },
  modalWrapper: {
    '& .MuiPaper-root': {
      maxWidth: '100%'
    }
  },
  modalHeaderRight: {
    display: 'flex',
    float: 'right'
  },
  modalActionButtons: {
    display: 'flex',

    '& span': {
      width: '1rem',
      borderRight: '1px solid #EDEDED',
      paddingLeft: '10px'
    },
    '& svg': {
      width: '1.5rem',
      height: '1.5rem',
      fontSize: '1.75rem',
      marginLeft: 'px',
      '&:hover': {
        cursor: 'pointer'
      }
    }
  },
  checkBoxes: {
    color: `#15C7C0 !important`
  },
  checkBoxOff: {
    color: '#6c757d'
  }
};
